<template>
  <!--    vision-area-start-->
  <div class="vision-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title">
            <h3>{{ article.title }}</h3>
            <p>
              {{ article.subTitle }}
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="single-team vision">
            <div class="team-img">
              <img src="assets/img/v1.png" alt="" />
            </div>
            <div class="team-containt" v-html="article.text"></div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="single-team vision">
            <div class="team-img">
              <img src="assets/img/v2.png" alt="" />
            </div>
            <div class="team-containt team-containt-special" v-html="article.textBox"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--    vision-area-end-->
</template>

<script>
import { getArticleById } from '@/api/navItems';
import { translate } from '@/lib/utils';

export default {
  created() {
    getArticleById(this.articleId).then(res => {
      console.log(res);
      this.article = translate(res);
    });
  },
  props: {
    slug: {
      type: String
    },
    articleId: {
      type: String
    }
  },
  data() {
    return {
      article: {}
    };
  }
};
</script>

<style lang="scss" scoped>
.section-title h3 {
  max-width: 580px;
  margin-left: auto;
  margin-right: auto;
}

.section-title p {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
</style>
